// @flow

import { SET_SUBSCRIPTION_ID } from './actionTypes';

export const setSubscriptionId = (subscriptionId: ?string = null): TrovitAction => ({
  type: SET_SUBSCRIPTION_ID,
  payload: {
    subscriptionId,
  },
});



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/Authentication/actions.js